import $ from 'jquery';
import Handlebars from 'handlebars';
import filtersAnimations from 'lib/animations/filters.animations';
import getParameterByName from 'lib/getParameterByName';
import PageCache from 'lib/page-cache';
import langFromUrl from 'lib/util/langFromUrl';
import 'lib/loader/series';
import 'lib/transforms/series.mapByCode';
import 'lib/helpers/offer-bundle';
import bat from 'components/bat'; // bat.hcompile
import 'components/isotope';
import readableMonetize from 'lib/readable-monetize';

var __initialized = false;
var __allAppliedFilters = [];

var IsotopeFilters = function (ajaxComponent, isForOffers) {
  this.filtersByCategory = {};
  this.allIsotopeFilters = [];
  this.allAppliedFilterParams = [];
  this.ajaxQueue = [];
  this.urlsAndTheirIndexes = [];
  this.ajaxComponent = ajaxComponent;
  this.isForOffers = isForOffers;
  this.sortAscending = true;
  if (!__initialized) { this.init(); }
};

// previously found in global.js
// used by offers.filters.js on IsotopeFilters
Array.prototype.clear = function () { // eslint-disable-line no-extend-native
  while (this.length > 0) {
    this.pop();
  }
};

$.extend(IsotopeFilters.prototype, {
  init: function () {
    var self = this;
    __initialized = true;
    var locali18n = {
      en: {
        clear: 'CLEAR', allSelected: 'All Selected', selected: 'Selected', show: 'Show', offers: 'Offers'
      },
      es: {
        clear: 'BORRAR', allSelected: 'Elegiste todo', selected: 'Elegiste', show: 'Ver', offers: 'oferta(s)'
      }
    };
    self.lang = langFromUrl();
    self.locali18n = locali18n[self.lang] || locali18n.en;
    self.promoItemsMap = {};
    self.$stickyFilters = $('#filters-panel .sticky-head'); // NEEDS to be sticky-head, as #filters-pane .sticky is not accurate

    if ($('#filter-promotions').length) {
      var promoItems = $('#filter-promotions div input');
      promoItems.each(function (index, element) {
        var elItem = $(element);
        self.promoItemsMap[elItem.attr('data-name')] = elItem.attr('data-param-value');
      });
    }

    // CAT-377
    self.existingParams = window.location.search;
    var io = this.existingParams.indexOf('&');
    if (io !== -1) {
      self.paramsAfterFilters = self.existingParams.substr(io);
    }

    $('#filter-promotions input[data-toggle-filter]').each(function () {
      var data = $(this).data('toggle-filter');
      data = Handlebars.helpers.classify(data).string;
      $(this).data('toggle-filter', data);
    });

    if (self.$stickyFilters.length > 0) {
      self.addFab();
      var clearBtn$ = $(self.$stickyFilters).find('a').length > 0 ? $(self.$stickyFilters).find('a')[0] : null;
      if (!clearBtn$) {
        clearBtn$ = $("<a class='clear-filters-button datalayer-link'>" + self.locali18n.clear + '</a>');
        $(self.$stickyFilters).prepend(clearBtn$);
      }
    }

    $('#close-filters-button, #done-button').click(function () {
      self.applyFilters();
      filtersAnimations.close();
    });

    $('.clear-filters-button').click(function () {
      self.clearFilters();
    });

    // reset all filters to off on pageload
    $('#filters-panel input[type="checkbox"]').attr('checked', false);
    var a = false;
    $('#filters-panel').find('input[data-toggle-filter]').each(function (k, v) {
      if ($(v).is(':checked')) {
        a = true;
        checkRoute(v, true);
      }
      if ($('#filters-panel').find('input[data-toggle-filter]').length == (k + 1)) {
        setTimeout(function () {
          self.combineFilters();
        }, 1500);
      }
    });

    // filter click
    $('#filters-panel').on('click', '[data-toggle-filter]', function (e) {
      // CAT-3593 HUMAN CLICK, CLEAR EXITING.
      self.existingParams = null;
      self.paramsAfterFilters = null;
      if (self.ajaxComponent && self.ajaxComponent.$isotopeContainer && self.ajaxComponent.$isotopeContainer.isotope) {
        self.ajaxComponent.$isotopeContainer.isotope('remove', self.ajaxComponent.$isotopeContainer.find('.isotope-item'), function () {
          self.ajaxComponent.clearCached();
        });
      }
      checkRoute(e.target, false);
    });

    function checkRoute(e, f) {
      var $this = $(e);
      self.filter($this, f);
      var checkedVehicles = '';
      var checkedInventoryValues = '';
      var date = new Date();
      date.setTime(date.getTime() + (22 * 60 * 60 * 1000));
      $('#filter-vehicles').find('input[type=checkbox]:checked').each(function (t) {
        checkedVehicles = checkedVehicles + '!!' + $(this).attr('id');
      });

      $('#filter-offer-types').find('input[type=checkbox]:checked').each(function (t) {
        checkedVehicles = checkedVehicles + '!!' + $(this).attr('id');
      });

      $('#filter-promotions').find('input[type=checkbox]:checked').each(function (t) {
        checkedVehicles = checkedVehicles + '!!' + $(this).attr('id');
      });

      $('#filter-models').find('input[type=checkbox]:checked').each(function (t) {
        checkedVehicles = checkedVehicles + '!!' + $(this).attr('id');
        // Inventory Cookie
        checkedInventoryValues = checkedInventoryValues + '!!' + $(this).attr('id');
      });

      $('#filter-engine').find('input[type=checkbox]:checked').each(function (t) {
        checkedInventoryValues = checkedInventoryValues + '!!' + $(this).attr('id');
      });

      $('#filter-transmission').find('input[type=checkbox]:checked').each(function (t) {
        checkedInventoryValues = checkedInventoryValues + '!!' + $(this).attr('id');
      });

      $('#filter-packages').find('input[type=checkbox]:checked').each(function (t) {
        checkedInventoryValues = checkedInventoryValues + '!!' + $(this).attr('id');
      });

      $('#filter-color').find('input[type=checkbox]:checked').each(function (t) {
        checkedInventoryValues = checkedInventoryValues + '!!' + $(this).attr('id');
      });
    }

    // BAT2980: CAPTURE FILTERS ON QUERY STRING.
    var qFilters = getParameterByName('filters'); // ['apr', 'avalon', 'camry'];
    if (qFilters && qFilters.length) {
      self.featured = qFilters.indexOf('featured') !== -1;
    }

    if (qFilters && self.isForOffers) {
      self.hasQueryFilters = true;
      var qStore = qFilters.split(',');
      // REMOVE DUPLICATES.
      qStore = qStore.filter(function (value, index, array) {
        return array.indexOf(value) == index;
      });

      self.preselectedFilters = qStore; // USED LATER FOR STATE.
      var lis = $('#filters-panel li input');
      lis.each(function (index, item) {
        if (qStore.indexOf($(item).data().name) !== -1) {
          $(item).closest('ul').addClass('in');
          $(item).prop('checked', true);
        }
      });
    }

    if (!a) { self.combineFilters(); }

    var totalCount = '0';
    setTimeout(function () {
      totalCount = $('.legend-center span.total-found').text();
    }, 1500);

    // For Offers Scroll Position
    var currentPageUrlName = window.location.pathname;
    $('a[data-label-key]').on('click', function (e, dontRun) {
      e.preventDefault();
      if ($(this).attr('data-label-id') != 'undefined' && typeof $(this).attr('data-label-id') !== 'undefined') {
        $(this).attr('data-label-id', $(this).attr('data-label-id').replace(/[^\w-&\.]/g, '').replace(/&/g, 'amp').replace(/\./g, '-'));
      }
      var date = new Date();
      date.setTime(date.getTime() + (22 * 60 * 60 * 1000));
      var val = $(this).data('label-key');
      var currentPageUrl = window.location.pathname;
      // Added for TRE-15 - Back button improvements

      if (!dontRun) {
        $('.tab-filter-select').trigger('change', [true, val]);
        self.toggleLabelFilters($(this));
      }
    });

    setTimeout(function () {
      // console.log("Timed Filters Length ",$('.tab-filter-select').children("option").length);
      $('.tab-filter-select').on('change', function (e, dontRun, index) {
        // console.log('SELECTED!', dontRun, index);
        if ($(this).children('option:selected').attr('data-label-id') != 'undefined' && typeof $(this).children('option:selected').attr('data-label-id') !== 'undefined') {
          $(this).children('option:selected').attr('data-label-id', $(this).children('option:selected').attr('data-label-id').replace(/[^\w-&\.]/g, '').replace(/&/g, 'amp').replace(/\./g, '-'));
        }

        if (index) {
          $('.tab-filter-select').val(index);
        } else {
          var val = $(this).find('option:selected').data('label-key');
          if (!dontRun) {
            $('a[data-label-key="' + val + '"]').trigger('click', [true]);
            self.toggleLabelFilters($(this).find('option:selected'));
          }
        }
      });
    }, 3500);

    $('.tab-filter-select').dropkick({ mobile: false });
    $('#sort-by-select-inventory').on('change', function () {
      var val = $(this).find(':selected').val();
      if (val === 'lowest') {
        self.sortAscending = true;
      } else {
        self.sortAscending = false;
      }
      self.ajaxComponent.$isotopeContainer.isotope('remove', self.ajaxComponent.$isotopeContainer.find('.isotope-item'), function () {
        self.ajaxComponent.clearCached();
        self.addFilter(self.allAppliedFilterParams.join(''), self.ajaxQueue);
        self.combineFilters();
      });
    });

    $('#sort-by-select').on('change', function () {
      var string = $(this).find(':selected').text().split(' ').join('-').toLowerCase();
      bat.SELECTED_SORT_LABEL = string;
      self.ajaxComponent.$isotopeContainer.isotope('updateSortData', self.ajaxComponent.$isotopeContainer.find('.isotope-item'));
      self.ajaxComponent.$isotopeContainer.isotope({ sortBy: 'label' });
    });

    // BAT-5270 toggle atribute aria-expanded
    $("#filters-panel .sticky .filters button").click(function(){
      $(this).attr('aria-expanded', function(index, attr){
          return attr == 'false' ? 'true' : 'false';
      });
    });

    // add comma in the dollar ammount - Mirai offer details
    var extraAmmountValue = $('.extra-cash-amt').html();
    if(typeof extraAmmountValue !== 'undefined'){
      $('.extra-cash-amt').html(readableMonetize(extraAmmountValue));
    }



    // ajax filters in
    // TODO: move to all-offers handling. Currently in use on series based offer pages (/offers/avalon)
    if (self.isForOffers) {
      if ($('#all-offers').data('series')) {
        PageCache.await('series.map')
          .then(function (seriesMap) {
            var series = '';
            series = $('#all-offers').data('series');
            var year = seriesMap[series].year;

            $.ajax({
              dataType: 'json',
              url: '/BATWS/cls/getTrimModel/' + year + '/' + series + '.json',
              beforeSend: function (xhrObj) {
                xhrObj.setRequestHeader('Content-Type', 'application/json');
                xhrObj.setRequestHeader('Accept', 'application/json');
                xhrObj.overrideMimeType('application/json');
              }
            }).done(function (ajaxData) {
              var data = { items: [] };
              var year = ajaxData.trimModelInfo.year;
              var modelNames = Object.keys(ajaxData.trimModelInfo.models);
              var models = ajaxData.trimModelInfo.models;

              for (var i = 0; i < modelNames.length; i++) {
                var model = { name: modelNames[i] }	;

                var trims = models[modelNames[i]];
                var paramValues = [];

                for (var j = 0; j < trims.length; j++) {
                  paramValues.push(year + '-' + trims[j].trimId);
                  paramValues.push(year + '.5-' + trims[j].trimId); // also add years with .5
                }

                model.trimCodes = 'trim-' + paramValues.join(',trim-');
                model.paramKey = 'model';
                model.paramValue = paramValues.join('&model=');
                data.items.push(model);
              }

              var handlebarsHTML = bat.hcompile($('#template-offer-model-filters').html(), data);
              var $newItems = $(handlebarsHTML);
              $('#filter-models').empty();
              $('#filter-models').append($newItems);
            }).fail(function (jqXHR, textStatus, errorThrown) {
              // console.log('!!!!!!!failed to get models!!!!!!!');
            });
          });
      }
    }
  },

  // mobile-18, adds the (offers) filter button to bottom right
  addFab: function () {
    import('bat-next')
      .then(function (BATNext) {
        BATNext.FABController.registerFab({
          id: 'fab-filter-offers',
          weight: 50,
          icon: 'icon-filter',
          text: 'filter open',
          onClick: function () {
            filtersAnimations.open();
          }
        });
        if (!BATNext.FABController.isMounted()) {
          BATNext.FABController.mountFabContainer(document.getElementById('fab-container'));
        }
      });
  },

  filter: function ($this, dontAjax) {
    var self = this;
    var $selectedFilters = $this.parents('.checkboxes').siblings('.selected-filters');
    var name = $this.data('name');
    var toggleFilters = $this.data('toggle-filter').toString().split(',');
    var paramKey = $this.data('param-key');
    var paramValue = $this.data('param-value');
    var paramString = '&' + encodeURIComponent(paramKey) + '=' + encodeURIComponent(paramValue);
    paramString = paramString.split('%26model%3D').join('&model='); // fix for multiple trim codes on vehicle specific offers page
    paramString = paramString.split('%26accessories%3D').join('&accessories=');
    var $parent = $this.parents('.checkboxes');
    var parentID = $parent.attr('id');
    var array = [];

    if (self.filtersByCategory[parentID] === null || self.filtersByCategory[parentID] === undefined) {
      self.filtersByCategory[parentID] = [];
      array = self.filtersByCategory[parentID];
    } else {
      array = self.filtersByCategory[parentID];
    }

    if ($this.is(':checked')) {
      var $li = $('<li id="selected-filter-' + name + '""></li>').append($this.siblings('label').clone().prepend('<i class="icon icon-close"></i>'));
      $selectedFilters.append($li);
      self.addFilter(paramString, self.allAppliedFilterParams); // push param string to allAppliedFilterParams array
      self.addFilter(self.allAppliedFilterParams.join(''), self.ajaxQueue); // push entire allAppliedFilterParams array as a string to ajaxQueue array

      for (var i = 0; i < toggleFilters.length; i++) {
        self.addFilter(toggleFilters[i], __allAppliedFilters); // add filter name to global ALL_APPLIED_FILTERS array
        self.addFilter('.' + toggleFilters[i], array);
      }
    } else {
      $selectedFilters.children('#selected-filter-' + name).remove();
      self.removeFilter(paramString, self.allAppliedFilterParams);
      self.addFilter(self.allAppliedFilterParams.join(''), self.ajaxQueue);

      for (var i = 0; i < toggleFilters.length; i++) {
        self.removeFilter(toggleFilters[i], __allAppliedFilters); // add filter name to global ALL_APPLIED_FILTERS array
        self.removeFilter('.' + toggleFilters[i], array);
      }
    }

    if (!dontAjax) { self.combineFilters(); }
  },

  toggleLabelFilters: function ($obj) {
    var self = this;
    var $this = $obj;
    var labelKey = $this.data('label-key');
    var labelId = $this.data('label-id');

    if (labelKey != 0 && (labelKey == '' || labelKey == null || typeof labelKey === 'undefined' || labelKey == 'undefined')) {
      labelKey = 'featured';
    }
    self.filtersByCategory = {};
    self.filtersByCategory['labels'] = [];

    if (labelKey === 'featured') {
      self.addFilter('*', self.filtersByCategory['labels']);
      self.addFilter('', self.ajaxQueue);
    } else {
      self.addFilter('&offerLabels=' + labelKey.toString(), self.ajaxQueue);
      self.addFilter('.' + labelId.toString(), self.filtersByCategory['labels']);
    }
    self.combineFilters();

    $('.filters-tabs li').each(function () {
      $(this).removeClass('active');
    });

    $this.parent().addClass('active');
  },

  clearFilters: function () {
    var ioAF = this.allAppliedFilterParams.indexOf('&featured=true');
    if (ioAF > 0) {
      this.allAppliedFilterParams.splice(ioAF, 1);
    }
    var self = this;
    self.featured = null;// false; //BAT-3538.
    self.existingParams = null;
    self.paramsAfterFilters = null;
    self.clearFiltersFromQueryString();
    // get model name before clearing and pass to analytics
    var allCheckedInputs = $('input:checked');
    var modelNamesBeforeClear = $('#filter-models').find(allCheckedInputs).map(function () { return $(this).attr('data-name'); }).get().join(',');
    if (modelNamesBeforeClear == '') { modelNamesBeforeClear = 'no_model_filters_applied'; }

    $('#filters-panel input[type="checkbox"]:checked').each(function () {
      // $(this).attr('checked', false);
      $(this).prop('checked', false);
      self.filter($(this), true);
    });

    // BAT-3280 After clear filters button is clicked
    // default filters-tabs to first child ie. featured
    $('.filters-tabs li').each(function () {
      $(this).removeClass('active');
    });

    $('.filters-tabs li:first-child').addClass('active');

    $('.tab-filter-select').val('featured').dropkick('refresh');

    self.filtersByCategory = {};
    self.ajaxQueue.length = 0;
    self.ajaxComponent.paramString = '';
    self.addFilter('', self.ajaxQueue);
    self.combineFilters();
  },

  runAjaxQueue: function () {
    var self = this;
    if (self.ajaxComponent && self.ajaxQueue.length > 0) {
      self.callAjax();
    }
  },

  callAjax: function () {
    var self = this;
    // BAT-3538 update the query keys if this contains featured, just before it hits the service.
    if (self.featured) {
      for (var i = 0; i < this.ajaxQueue.length; i++) {
        var ioa = this.ajaxQueue[i].toString().indexOf('&series');
        var iob = this.ajaxQueue[i].toString().indexOf('&offerType');
        if (ioa !== -1) {
          this.ajaxQueue[i] = this.ajaxQueue[i].replace('&series', '&featuredSeries');
        }
        if (iob !== -1) {
          this.ajaxQueue[i] = this.ajaxQueue[i].replace('&offerType', '&featuredType');
        }
      }
    }
    // Modified paramString for CAT-149 to support
    this.ajaxComponent.paramString = this.ajaxQueue[this.ajaxQueue.length - 1];
    var sortType = this.sortAscending ? 'asc' : 'desc'; // SORT HERE NOT USED.
    this.ajaxQueue.shift();

    this.ajaxComponent.init();
  },

  addFilter: function (value, array) {
    if (array.indexOf(value) <= -1) {
      array.push(value);
    }
  },

  removeFilter: function (value, array) {
    if (array.indexOf(value) > -1) {
      array.splice(array.indexOf(value), 1);
    }
  },

  combineFilters: function () {
    var self = this;
    if (self.filtersByCategory['filter-models']) {
      self.removeFilter('all-trims', __allAppliedFilters);
      self.removeFilter('.all-trims', self.filtersByCategory['filter-models']);

      if (self.filtersByCategory['filter-models'].length > 0) {
        self.addFilter('all-trims', __allAppliedFilters);
        self.addFilter('.all-trims', self.filtersByCategory['filter-models']);
      }
    }

    self.allIsotopeFilters.clear();

    function combine(array) {
      var r = []; var arg = array; var max = arg.length - 1;
      function helper(arr, i) {
        for (var j = 0, l = arg[i].length; j < l; j++) {
          var a = arr.slice(0); // clone arr
          a.push(arg[i][j]);
          if (i == max) {
            r.push(a.join(''));
          } else {
            helper(a, i + 1);
          }
        }
      }
      helper([], 0);
      return r;
    };
    // console.log('::: self.preselectedFilters', self.preselectedFilters)
    var combineArray = [];
    // MANIPULATE RECEIEVED PARAM VARS AND ADD THEM TO allAppliedFilterParams.
    if (self.preselectedFilters && self.preselectedFilters.length) {
      for (var p = 0; p < self.preselectedFilters.length; p++) {
        var paramString; var paramKey; var paramValue; var mappedPromoItem;
        var item = self.preselectedFilters[p];

        paramValue = item;
        mappedPromoItem = self.promoItemsMap[item];

        if (item === 'apr' || item === 'cash' || item === 'lease' || item === 'msrp' || item === 'misc') {
          if (!self.filtersByCategory['filter-offer-types']) {
            self.filtersByCategory['filter-offer-types'] = [];
          }
          paramKey = 'offerType';
          self.filtersByCategory['filter-offer-types'].push('.' + item);
        } else if (mappedPromoItem) {
        // else if (item ===  'cars-and-minivan'  || item === 'crossovers-and-suvs' || item === 'trucks'  || item === 'hybrids'  || item ===  'best-offer') {
          if (!self.filtersByCategory['filter-promotions']) {
            self.filtersByCategory['filter-promotions'] = [];
          }
          paramKey = 'offerLabels';
          qItem = self.promoItemsMap[item];
          paramValue = qItem;
          self.filtersByCategory['filter-promotions'].push('.' + item);
        } else if (item === 'featured') {
          paramKey = 'featured';
          paramValue = 'true';
        } else {
          if (!self.filtersByCategory['undefined']) {
            self.filtersByCategory['undefined'] = [];
          }
          paramKey = 'series';
          self.filtersByCategory['undefined'].push('.' + item);
        }
        paramString = '&' + encodeURIComponent(paramKey) + '=' + encodeURIComponent(paramValue);
        // console.log( ' :::paramString [' + paramString + ']');
        self.addFilter(paramString, self.allAppliedFilterParams); // push param string to allAppliedFilterParams array
        // self.addFilter(self.allAppliedFilterParams.join(''), self.ajaxQueue); //THIS RUNS THE Queue, DON'T DO THIS.
      }
      self.preselectedFilters = null;
    }

    $.each(self.filtersByCategory, function (key, value) {
      if (value.length > 0) {
        combineArray.push(value);
      }
    });

    if (combineArray.length > 0) {
      this.allIsotopeFilters = combine(combineArray);
    } else {
      if (self.isForOffers) {
        this.clearFiltersFromLinks();
      }
      this.allIsotopeFilters = ['*'];
    }
    this.applyFilters();

    if (self.isForOffers && combineArray.length) {
      setTimeout(function () {
        // console.log( ':::: appendFiltersToQueryString timeout :::');
        self.appendFiltersToQueryString(combineArray);
      }, 2000);
    }
    self.addFilterCounts();
    if (self.isForOffers && !combineArray.length) {
      self.appendFiltersToQueryString([]); // RESET THE URL.
    }
  },

  // BAT25-505 add filter counts
  addFilterCounts: function () {
    var self = this;
    var allSelectedFiltersCnt = 0;
    $('#filters-panel .filters').children('li').not('.ul-wrapper').each(function (idx, el) {
      var totalCnt = $(el).find(':checkbox').length;
      var checkedCnt = $(el).find(':checked').length;
      var btn$ = $(el).find('button').length > 0 ? $(el).find('button')[0] : null;
      if (btn$ && totalCnt > 0) {
        var span$ = $(btn$).find('.filter-count').length > 0 ? $(btn$).find('.filter-count')[0] : null;
        if (!span$) {
          span$ = $("<span class='filter-count'></span>");
          $(btn$).find('i').before(span$);
        }
        var showCnt = '';
        if (totalCnt === checkedCnt) showCnt = self.locali18n.allSelected;
        else if (checkedCnt > 0) showCnt = self.lang === 'es' ? (self.locali18n.selected + ' ' + checkedCnt) : (checkedCnt + ' ' + self.locali18n.selected);
        $(span$).html(showCnt);
      }
      allSelectedFiltersCnt += checkedCnt;
    });
    var headSpan$ = $('#filters-panel .sticky-head span');
    if (headSpan$.length > 0) {
      var hdNumSpan$ = $(headSpan$).find('.filter-count-head').length > 0 ? $(headSpan$).find('.filter-count-head')[0] : null;
      if (!hdNumSpan$) {
        hdNumSpan$ = $("<span class='filter-count-head'></span>");
        $(headSpan$).append(hdNumSpan$);
      }
      var txt = '';
      if (allSelectedFiltersCnt > 0) txt = '(' + allSelectedFiltersCnt + ')';
      $(hdNumSpan$).text(txt);
    }
    var btnDone$ = $('#done-button');
    if (btnDone$ && !(btnDone$.find('span').length > 0)) {
      $(btnDone$).html(self.locali18n.show + " <span class='total-found'></span> " + self.locali18n.offers);
    }
  },

  // BAT-2980. ADD &filters= TO QUERY STRING, CAUGHT BY OFFERS DETAIL PAGE, AND PASSED BACK WITH 'back to results' link.
  appendFiltersToQueryString: function (list) {
    var self = this;
    // console.log(' ::: appendFiltersToQueryString, list:', list, '\n self.featured', self.featured);
    self.clearFiltersFromLinks();
    var filterstring = '';
    var urlFilterString = '';
    var temp = [];
    for (var i = 0; i < list.length; i++) {
      for (var x = 0; x < list[i].length; x++) {
        var item = list[i][x].replace('.', '');
        if (temp.indexOf(item) === -1) { // NO DUPES.
          temp.push(item);
        }
      }
    }

    if (temp.length) {
      filterstring = '&filters=';
      urlFilterString = '?filters=';
      // NEED TO INLCUDE 'featured' for qstring.
      if (self.featured) {
        temp.push('featured');
      }
      for (var t = 0; t < temp.length; t++) {
        if (t === 0) {
          urlFilterString += encodeURIComponent(temp[t]);
          filterstring += encodeURIComponent(temp[t]);
        } else {
          var encoded = encodeURIComponent((',' + temp[t]));
          filterstring += encoded;
          urlFilterString += encoded;
        }
      }
      // CAT-377
      if (self.paramsAfterFilters && self.paramsAfterFilters.length) {
        self.paramsAfterFilters.replace('?', '&');
        urlFilterString += self.paramsAfterFilters;
      }
      var cards = $('.card-content a');
      cards.each(function (index, item) {
        var currentLink = $(item).attr('href');
        var newlink = currentLink += filterstring;
        $(item).attr('href', newlink);
      });
    } else {
      urlFilterString = '';
    }
    // CAT-377 filterstring indicates local filtering logic.
    if (self.existingParams && self.existingParams.length && !filterstring.length) {
      urlFilterString += self.existingParams;
    }
    // console.log('\n :::urlFilterString:[' +  urlFilterString + ']');
    // UPDATE THE LOCATION / HISTORY IN CASE USER WANTS TO SHARE.
    var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + urlFilterString;// '?myNewUrlQuery=1';
    // console.log('\n :::newurl:[' +  newurl + ']');
    window.history.replaceState({ path: newurl }, '', newurl);
  },

  // BAT-3538:
  clearFiltersFromQueryString: function () {
    var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname;
    window.history.replaceState({ path: newurl }, '', newurl);
  },

  // BAT-2980. IF FILTERS HAVE BEEN CLEARED, REMOVE &filters= FROM QUERY STRING.
  clearFiltersFromLinks: function () {
    var cards = $('.card-content a');
    cards.each(function (index, item) {
      var currentLink = $(item).attr('href');
      if (currentLink.indexOf('&filters=') !== -1) {
        var correctedLink = currentLink.substring(0, currentLink.indexOf('&filters='));
        $(item).attr('href', correctedLink);
      }
    });
  },

  applyFilters: function () {
    var self = this;
    var filters = self.allIsotopeFilters.join(', ');
    if (self.allIsotopeFilters.length >= 1) {
      filters += ', #isotope-stamp';
    }

    var sortBy = self.isForOffers ? 'label' : 'price';

    self.ajaxComponent.$isotopeContainer.isotope(
      {
        filter: filters,
        sortBy: sortBy,
        sortAscending: self.sortAscending
      }
    );
    self.runAjaxQueue();
  }
});

export default IsotopeFilters;
